<section>
  <app-header></app-header>
  <section fxLayout="row" fxLayoutAlign="start start">
    <app-menu [fxHide]="!isSignedIn()" ></app-menu>
    <div fxFlex>
      <router-outlet></router-outlet>
    </div>
  </section>
</section>
